import React, { useState } from "react";

import { Autocomplete, Button, Stack, TextField } from "@mui/material";
import { PopoverContentProps } from "components/AiData/PopoverContent";
import { useMeasureParametersSelector } from "store";

export const ParameterPopoverContent: React.FC<PopoverContentProps> = ({
  openedCell,
  setOpenedCell,
  onChangeSpecificRecommendationValue
}) => {
  const measureParameters = useMeasureParametersSelector();
  const [measureParameter, setMeasureParameter] = useState<{ id: number; name: string } | null>(
    openedCell?.data.parameter.measure || null
  );

  return (
    <>
      <Autocomplete
        fullWidth
        value={measureParameter}
        options={measureParameters}
        slotProps={{
          popper: {
            placement: "bottom-start",
            modifiers: [
              {
                name: "preventOverflow",
                enabled: true,
                options: {
                  boundary: "viewport",
                  padding: 8
                }
              },
              {
                name: "flip",
                enabled: true,
                options: {
                  fallbackPlacements: ["top-start", "bottom-end", "top-end"]
                }
              }
            ]
          }
        }}
        renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: { id: number; name: string }) => (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        )}
        renderInput={(params) => <TextField {...params} label="Parameter" />}
        getOptionLabel={(option) => option.name}
        onChange={(_, option) => setMeasureParameter(option)}
      />

      <Stack sx={{ flexDirection: "row", justifyContent: "flex-end", gap: "10px" }}>
        <Button
          variant="outlined"
          onClick={() => {
            setOpenedCell(null);
            setMeasureParameter(null);
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={async () => {
            if (openedCell?.data) {
              openedCell.data.parameter.id &&
                (await onChangeSpecificRecommendationValue({
                  id: openedCell.data.parameter.id,
                  field: "measure",
                  // send id empty string for dropping measure from the parameter
                  value: { id: measureParameter?.id || "" }
                }));
            }
            setOpenedCell(null);
          }}
          variant="contained"
        >
          Apply
        </Button>
      </Stack>
    </>
  );
};
